import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { Box, Autocomplete, TextField, Popper, InputAdornment } from "@mui/material";
import API_BASE_URL from 'Components/API'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const CustomPopper = function (props) {
    return (
        <Popper
            {...props}
            modifiers={[
                {
                    name: "offset",
                    options: {
                        offset: [5, 15], // 👉 pushes dropdown 12px lower (adjust as needed)
                    },
                },
            ]}
        />
    );
};
const Analyze = ({ selectedProductSubTypeId }) => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const [availableProducts, setAvailableProducts] = useState([]);
    const [productDataIsReady, setProductDataIsReady] = useState(false);
    const [formValues, setFormValues] = useState({
        commodityId: null,
        productSubTypeId: selectedProductSubTypeId ? parseInt(selectedProductSubTypeId, 10) : null
    });
    const [productSubTypeId, setProductSubTypeId] = useState(selectedProductSubTypeId ? parseInt(selectedProductSubTypeId, 10) : null);
    const [formError, setFormError] = useState({
        class: '',
        msg: ''
    });
    const fetchAvailableProducts = async () => {
        try {
            const url = `${API_BASE_URL}/Analysis/GetCommodities?Lang=${currentLang}&ProductSubTypeId=${productSubTypeId ? productSubTypeId : ''}&pageSize=1000000`;
            const response = await fetch(url);
            const data = await response.json();
            if (data.isSuccess) {
                setAvailableProducts(data.results);
            }
            else if (data.isFailed) {
                setFormError({
                    class: 'danger',
                    msg: data.errors
                })
            }
        } catch (error) {
            console.error('Error fetching options:', error);
        }
        finally {
            setProductDataIsReady(true)
        }
    };
    useEffect(() => {
        fetchAvailableProducts();
    }, [productSubTypeId]);
    const handleCommodityChange = (event, value, reason) => {

    };
    return (
        <div className="megaMenuContent d-flex h-100 justify-content-between flex-column">
            <div className="d-flex justify-content-between w-100 flex-1">
                <div className="row analyze-bg align-items-center flex-1">
                    <div className="col-4 position-relative number-icons">
                        <span className="number-icon number-1">1</span>
                        <div className="card-box-10 card-box-sm">
                            <Autocomplete
                                disablePortal
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => e.stopPropagation()}
                                ListboxProps={{
                                    style: {
                                        maxHeight: 100,
                                        overflow: 'auto',
                                    },
                                }}
                                value={availableProducts.find((option) => option.id === formValues.commodityId) || null}
                                id="commodityId"
                                onChange={handleCommodityChange}
                                options={availableProducts}
                                getOptionLabel={(option) => option.name}
                                size="small"
                                popupIcon={null}
                                clearIcon={null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('searchGoodsByProducerOrSubgroup')}
                                        variant="outlined"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                paddingRight: "6px !important",   // ← override padding-right
                                            },
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                                                    <ExpandMoreIcon
                                                        onClick={() => {
                                                            // open dropdown manually
                                                            params.InputProps.ref.current?.parentElement
                                                                ?.querySelector("input")
                                                                ?.focus();
                                                        }}
                                                        sx={{ color: "#045ba7" }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}
                                PopperComponent={CustomPopper}
                                slotProps={{
                                    popper: {
                                        sx: {
                                            "& .MuiPaper-root": {
                                                backgroundColor: "#fff",
                                                color: "#000",
                                                fontSize: "14px",
                                                minWidth: "350px",
                                                maxWidth: "600px",
                                                whiteSpace: "normal",
                                                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                                                borderRadius: "8px",
                                                textAlign: "center",
                                            },
                                            "& .MuiAutocomplete-listbox": {
                                                padding: 0,
                                                "& .MuiAutocomplete-option": {
                                                    padding: "8px 16px",
                                                    "&[aria-selected='true']": {
                                                        backgroundColor: "#045BA7",
                                                        color: "#fff",
                                                    },
                                                    "&:hover": {
                                                        backgroundColor: "#045BA7",
                                                        color: "#fff",
                                                    },
                                                },
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-4 position-relative number-icons">
                        <span className="number-icon number-2">2</span>
                        <div className="card-box-10 card-box-sm">
                            <Autocomplete
                                disablePortal
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => e.stopPropagation()}
                                ListboxProps={{
                                    style: {
                                        maxHeight: 100,
                                        overflow: 'auto',
                                    },
                                }}
                                value={availableProducts.find((option) => option.id === formValues.commodityId) || null}
                                id="commodityId"
                                onChange={handleCommodityChange}
                                options={availableProducts}
                                getOptionLabel={(option) => option.name}
                                size="small"
                                popupIcon={null}
                                clearIcon={null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('selectGoods')}
                                        variant="outlined"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                paddingRight: "6px !important",   // ← override padding-right
                                            },
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                                                    <ExpandMoreIcon
                                                        onClick={() => {
                                                            // open dropdown manually
                                                            params.InputProps.ref.current?.parentElement
                                                                ?.querySelector("input")
                                                                ?.focus();
                                                        }}
                                                        sx={{ color: "#045ba7" }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}
                                PopperComponent={CustomPopper}
                                slotProps={{
                                    popper: {
                                        sx: {
                                            "& .MuiPaper-root": {
                                                backgroundColor: "#fff",
                                                color: "#000",
                                                fontSize: "14px",
                                                minWidth: "350px",
                                                maxWidth: "600px",
                                                whiteSpace: "normal",
                                                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                                                borderRadius: "8px",
                                                textAlign: "center",
                                            },
                                            "& .MuiAutocomplete-listbox": {
                                                padding: 0,
                                                "& .MuiAutocomplete-option": {
                                                    padding: "8px 16px",
                                                    "&[aria-selected='true']": {
                                                        backgroundColor: "#045BA7",
                                                        color: "#fff",
                                                    },
                                                    "&:hover": {
                                                        backgroundColor: "#045BA7",
                                                        color: "#fff",
                                                    },
                                                },
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-4 position-relative number-icons">
                        <span className="number-icon number-3">3</span>
                        <div className="card-box-10 card-box-sm">
                            <Autocomplete
                                disablePortal
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => e.stopPropagation()}
                                ListboxProps={{
                                    style: {
                                        maxHeight: 100,
                                        overflow: 'auto',
                                    },
                                }}
                                value={availableProducts.find((option) => option.id === formValues.commodityId) || null}
                                id="commodityId"
                                onChange={handleCommodityChange}
                                options={availableProducts}
                                getOptionLabel={(option) => option.name}
                                size="small"
                                popupIcon={null}
                                clearIcon={null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={t('selectProducer')}
                                        variant="outlined"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                paddingRight: "6px !important",   // ← override padding-right
                                            },
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                                                    <ExpandMoreIcon
                                                        onClick={() => {
                                                            // open dropdown manually
                                                            params.InputProps.ref.current?.parentElement
                                                                ?.querySelector("input")
                                                                ?.focus();
                                                        }}
                                                        sx={{ color: "#045ba7" }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}
                                PopperComponent={CustomPopper}
                                slotProps={{
                                    popper: {
                                        sx: {
                                            "& .MuiPaper-root": {
                                                backgroundColor: "#fff",
                                                color: "#000",
                                                fontSize: "14px",
                                                minWidth: "350px",
                                                maxWidth: "600px",
                                                whiteSpace: "normal",
                                                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                                                borderRadius: "8px",
                                                textAlign: "center",
                                            },
                                            "& .MuiAutocomplete-listbox": {
                                                padding: 0,
                                                "& .MuiAutocomplete-option": {
                                                    padding: "8px 16px",
                                                    "&[aria-selected='true']": {
                                                        backgroundColor: "#045BA7",
                                                        color: "#fff",
                                                    },
                                                    "&:hover": {
                                                        backgroundColor: "#045BA7",
                                                        color: "#fff",
                                                    },
                                                },
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-between">
                <div className="justify-content-end mt-2 d-flex">
                    <a href="/Analyze/Producers" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1 align-self-end justify-self-end" >
                        {t("enterProductAnalysisDashboard")}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Analyze;
